export default __webpack_public_path__ + "static/media/image2.7562737d.jpg";